import React, { useEffect, useRef, useState } from "react";
import Datepicker from "tailwind-datepicker-react";

const options = {
  title: "",
  autoHide: true,
  todayBtn: true,
  clearBtn: true,
  theme: {
    background: "bg-white dark:bg-white",
    todayBtn: "bg-red-700 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-700",
    clearBtn: "bg-white text-black border hover:bg-initial dark:bg-white dark:text-black dark:hover:bg-initial",
    icons: "bg-white text-black hover:bg-gray-100 hover:text-black dark:bg-white dark:text-black dark:hover:bg-gray-100 dark:hover:text-black",
    text: "text-black hover:bg-red-700 hover:text-white dark:text-black dark:hover:bg-red-700 dark:hover:text-white",
    disabledText: "pointer-events-none	text-black bg-gray-200 opacity-10 dark:text-black dark:bg-gray-200",
    // input: "bg-white text-black dark:bg-white dark:text-black",
    selected: "bg-red-700 text-[#ffff] dark:bg-red-700 dark:text-[#ffff]",
  },
  language: "en",
};

const DatePicker = (props) => {
  //   const [value, setValue] = useState();
  //   const [isFocued, setIsFocused] = useState(false);
  //   const textInput = useRef(null);

  //   useEffect(() => {
  //     if (isFocued === true) textInput.current.focus();
  //   }, [isFocued]);

  //   return (
  //     <div
  //       onClick={() => {
  //         setIsFocused(true);
  //       }}
  //     >
  //       <svg
  //         width={14}
  //         height={14}
  //         viewBox="0 0 14 14"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M2.99961 2.7001H3.49961V2.2001V1.4001C3.49961 1.32053 3.53122 1.24423 3.58748 1.18797C3.64374 1.1317 3.72004 1.1001 3.79961 1.1001C3.87917 1.1001 3.95548 1.1317 4.01174 1.18797C4.068 1.24423 4.09961 1.32053 4.09961 1.4001V2.2001V2.7001H4.59961H9.39961H9.89961V2.2001V1.4001C9.89961 1.32053 9.93122 1.24423 9.98748 1.18797C10.0437 1.1317 10.12 1.1001 10.1996 1.1001C10.2792 1.1001 10.3555 1.1317 10.4117 1.18797C10.468 1.24423 10.4996 1.32053 10.4996 1.4001V2.2001V2.7001H10.9996H11.7996C12.0913 2.7001 12.3711 2.81599 12.5774 3.02228L12.931 2.66873L12.5774 3.02228C12.7837 3.22857 12.8996 3.50836 12.8996 3.8001V11.8001C12.8996 12.0918 12.7837 12.3716 12.5774 12.5779C12.3711 12.7842 12.0913 12.9001 11.7996 12.9001H2.19961C1.90787 12.9001 1.62808 12.7842 1.42179 12.5779C1.2155 12.3716 1.09961 12.0918 1.09961 11.8001V3.8001C1.09961 3.50836 1.2155 3.22857 1.42179 3.02228C1.62808 2.81599 1.90787 2.7001 2.19961 2.7001H2.99961ZM3.79961 4.1001C3.45483 4.1001 3.12417 4.23706 2.88037 4.48086C2.63657 4.72466 2.49961 5.05532 2.49961 5.4001C2.49961 5.74488 2.63657 6.07554 2.88037 6.31934C3.12417 6.56313 3.45483 6.7001 3.79961 6.7001H10.1996C10.5444 6.7001 10.875 6.56313 11.1188 6.31934C11.3626 6.07554 11.4996 5.74488 11.4996 5.4001C11.4996 5.05532 11.3626 4.72466 11.1188 4.48086C10.8751 4.23706 10.5444 4.1001 10.1996 4.1001H3.79961Z"
  //           fill="#6B7280"
  //           stroke="#6B7280"
  //         />
  //       </svg>

  //       {!isFocued ? (
  //         "Select date"
  //       ) : (
  //         <input
  //           ref={textInput}
  //           type="date"
  //           onChange={(e) => setValue(e.target.value)}
  //           autoFocus
  //         />
  //       )}
  //     </div>
  //   );

  const [show, setShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const handleChange = (selectedDate) => {
    setSelectedDate(selectedDate);
    console.log(selectedDate);
  };
  const handleClose = (state) => {
    setShow(state);
  };

  return (
    <div>
      <Datepicker
        options={options}
        onChange={handleChange}
        show={show}
        setShow={handleClose}
      >
        <div style={{width: props.width}} className="flex h-[2.5rem] items-center pl-3 rounded-[8px] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] gap-4">
          <div>
            <svg
              width={14}
              height={14}
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.99961 2.7001H3.49961V2.2001V1.4001C3.49961 1.32053 3.53122 1.24423 3.58748 1.18797C3.64374 1.1317 3.72004 1.1001 3.79961 1.1001C3.87917 1.1001 3.95548 1.1317 4.01174 1.18797C4.068 1.24423 4.09961 1.32053 4.09961 1.4001V2.2001V2.7001H4.59961H9.39961H9.89961V2.2001V1.4001C9.89961 1.32053 9.93122 1.24423 9.98748 1.18797C10.0437 1.1317 10.12 1.1001 10.1996 1.1001C10.2792 1.1001 10.3555 1.1317 10.4117 1.18797C10.468 1.24423 10.4996 1.32053 10.4996 1.4001V2.2001V2.7001H10.9996H11.7996C12.0913 2.7001 12.3711 2.81599 12.5774 3.02228L12.931 2.66873L12.5774 3.02228C12.7837 3.22857 12.8996 3.50836 12.8996 3.8001V11.8001C12.8996 12.0918 12.7837 12.3716 12.5774 12.5779C12.3711 12.7842 12.0913 12.9001 11.7996 12.9001H2.19961C1.90787 12.9001 1.62808 12.7842 1.42179 12.5779C1.2155 12.3716 1.09961 12.0918 1.09961 11.8001V3.8001C1.09961 3.50836 1.2155 3.22857 1.42179 3.02228C1.62808 2.81599 1.90787 2.7001 2.19961 2.7001H2.99961ZM3.79961 4.1001C3.45483 4.1001 3.12417 4.23706 2.88037 4.48086C2.63657 4.72466 2.49961 5.05532 2.49961 5.4001C2.49961 5.74488 2.63657 6.07554 2.88037 6.31934C3.12417 6.56313 3.45483 6.7001 3.79961 6.7001H10.1996C10.5444 6.7001 10.875 6.56313 11.1188 6.31934C11.3626 6.07554 11.4996 5.74488 11.4996 5.4001C11.4996 5.05532 11.3626 4.72466 11.1188 4.48086C10.8751 4.23706 10.5444 4.1001 10.1996 4.1001H3.79961Z"
                fill="#6B7280"
                stroke="#6B7280"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Select Date"
            value={selectedDate}
            onFocus={() => setShow(true)}
            onBlur={() => setShow(false)}
            className="bg-[#F9FAFB] w-[85%] text-[14px] outline-none"
            readOnly
          />
        </div>
      </Datepicker>
    </div>
  );
};

export default DatePicker;
